import React from "react";
import { IClient } from "../../core/cm.types"
import { Table } from "../table/Table"
import { useMemo } from "react";
import { TableService } from "../../services/table.service";
import moment from "moment";

export const Entries: React.FunctionComponent<{ suffix: any, postfix: any, clients: IClient[], tableService: TableService, exportAllTable(rows) }> = (props) => {
    const { clients, suffix, postfix, tableService, exportAllTable } = props;

    //const today = (new Date()).getTime();
    const thisDay = moment(new Date()).startOf('day');

    const data = clients.filter((client) => {
        if (client?.entry?.date === undefined)
            return false;

        //const entryDate = Date.parse(client.entry.date);
        const entry = moment(client.entry.date).startOf('day');
        
        return entry >= thisDay;
    });

    const columns = useMemo(() => [
        tableService.getKeyColumn(),
        tableService.getFirstNameColumn(),
        tableService.getLastNameColumn(),
        tableService.getMailColumn(),
        tableService.getBirthdayColumn(),
        tableService.getTitleColumn(),
        tableService.getInterviewDateColumn(),
        tableService.getInterviewState(),
        tableService.getEntryDateColumn(),
        tableService.getEntryHourColumn(),
        tableService.getExitDateColumn(),
        tableService.getConsultantColumn(),
        tableService.getAmmStatusColumn(),
        tableService.getPensumColumn(),
        tableService.getQualificationColumn(),
        tableService.getEntryLocationColumn(),
        tableService.getEntryAdditionalinfoColumn(),
        tableService.getObjective1Column(),
        tableService.getObjective2Column(),
        tableService.getObjective3Column()
    ], [tableService]);
    //qualifications.length, locationInfo.length
    const sortBy = [
        { id: 'interview.date', desc: false }
    ];

    return (
        <Table data={data} columns={columns} columnssuffix={suffix} columnspostfix={postfix} sortBy={sortBy} exportAllTable={exportAllTable} />
    )
};
